import * as React from "../../_snowpack/pkg/react.js";
import SingleLine from "./SingleLine.js";
const AddressBlock = ({society}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SingleLine, {
    text: society.address_line_1
  }), /* @__PURE__ */ React.createElement(SingleLine, {
    text: society.address_line_2
  }), /* @__PURE__ */ React.createElement(SingleLine, {
    text: society.address_line_3
  }), /* @__PURE__ */ React.createElement(SingleLine, {
    text: society.address_line_4
  }), /* @__PURE__ */ React.createElement(SingleLine, {
    text: society.address_line_5
  }), /* @__PURE__ */ React.createElement(SingleLine, {
    text: society.address_line_6
  }));
};
export default AddressBlock;
